export const NET_ADMIN_ACCESS_LVL = 0
export const NODE_ACCESS_LVL = 1
export const CLIENT_ACCESS_LVL = 2
